import { useEffect, useState } from "react";
import logo from "../assets/nextx-logo.svg";

export function DashboardHeader({ title }: { title: string }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 30_000);
    return () => window.clearInterval(id);
  }, []);

  const timestamp = now.toLocaleTimeString("en-AU", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <header className="flex items-center justify-between px-12 pt-10">
      <div className="flex items-center gap-6">
        <img src={logo} alt="NextX" className="h-14" />
        <span className="text-2xl font-medium uppercase tracking-[0.3em] text-aqua/80">
          {title}
        </span>
      </div>
      <div className="text-right">
        <div className="tabular text-3xl font-semibold text-white">{timestamp}</div>
        <div className="text-sm uppercase tracking-wider text-aqua/60">
          {now.toLocaleDateString("en-AU", {
            weekday: "long",
            day: "numeric",
            month: "long",
          })}
        </div>
      </div>
    </header>
  );
}
